import { API_URL } from "./API/fetchBaseQuery";

//Defines the run/build mode accroding to mode api end point will be changed
export const IsProdMode = false;

//Defines api should be decrypted or not
export const IsEncryption = true;

//Defines url parameters should be encrypted or not
export const IsQueryParamsEncryption = true;

// AESKey for encryption and decryption
export const AESKeyValue = "azR2N3F4a3pycXFxd2M2dG5ya3E4MjBrbmYzZzM0YWU=";

// AESIV for encryption and decryption
export const AESIVKey = "enZjZmptNTEybWhvb2U4Mg==";

//Defines cookies should be encrypted or not
export const IsCookieEncryption = true;

//Basic Authentication key for token generation
// export const BasicAuthKey = "Basic U0dUZWNoOlNHVGVjaEAyMDIy";
export const BasicAuthKey = "U0dUZWNoOlNHVGVjaEAyMDIy";

export const value1 = "azR2N3F4a3pycXFxd2M2dG5ya3E4MjBrbmYzZzM0YWU=";

export const value2 = "enZjZmptNTEybWhvb2U4Mg==";

export const value3 = 'AuthUserWeb101';

export const value4 = 'Token101';

export const value5 = 'BasicToken101';

export const IPAShWebUrl = 'https://ipaswebtest.flyingcapetech.com/';

export const IPASEventsUrl = 'https://ipaseventtest.flyingcapetech.com/';

export const getImageWebUrl = `${API_URL}/Common/getImage?type=DisplayPhoto&fileName=`

export const AppId = 101

export const AdminPath = "https://admin.ipas.org.sg/";
